import { createSlice } from '@reduxjs/toolkit';

const savedTheme = localStorage.getItem('theme');
const initialTheme = savedTheme || 'light';

const initialState = {
  colorMode: initialTheme,
};

document.documentElement.setAttribute('data-theme', initialTheme);

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    toggleColorMode: (state) => {
      state.colorMode = state.colorMode === 'light' ? 'dark' : 'light';
      localStorage.setItem('theme', state.colorMode);
      document.documentElement.setAttribute('data-theme', state.colorMode);
    },
    setColorMode: (state, action) => {
      state.colorMode = action.payload;
      localStorage.setItem('theme', state.colorMode);
      document.documentElement.setAttribute('data-theme', state.colorMode);
    },
  },
});

export const { toggleColorMode, setColorMode } = uiSlice.actions;
export default uiSlice.reducer;
export { initialState as uiInitialState };
